import { Injectable } from '@angular/core';

/**
 * Avoid using this class when feasible!
 */
@Injectable({ providedIn: 'root' })
export class TestHookService {
  run(_hookId: symbol) {}
}
